import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Home } from 'lucide-react'

export default function NotFoundPage() {
    return (
        <div className="min-h-screen flex items-center justify-center font-mono px-6">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="text-center"
            >
                {/* Terminal error output */}
                <div className="terminal-window max-w-lg mx-auto text-left mb-8">
                    <div className="terminal-titlebar">
                        <span className="terminal-dot bg-[#ff5f57]" />
                        <span className="terminal-dot bg-[#ffbd2e]" />
                        <span className="terminal-dot bg-[#28c840]" />
                        <span className="ml-3 text-[10px] text-[#444]">404 — zsh: command not found</span>
                    </div>
                    <div className="p-6 space-y-2 text-sm">
                        <p>
                            <span className="text-primary">rapheal@portfolio</span>
                            <span className="text-[#444]">:~$</span>
                            <span className="text-foreground ml-2">cd {window.location.pathname}</span>
                        </p>
                        <p className="text-[#666]">
                            zsh: <span className="text-red-400">no such file or directory</span>: {window.location.pathname}
                        </p>
                        <p className="text-[#555] text-xs mt-4">
                            The page you're looking for doesn't exist or has been moved.
                        </p>
                        <p>
                            <span className="text-primary">rapheal@portfolio</span>
                            <span className="text-[#444]">:~$</span>
                            <span className="animate-blink inline-block w-2 h-4 bg-foreground align-middle ml-1" />
                        </p>
                    </div>
                </div>

                {/* Back home */}
                <Link
                    to="/"
                    className="btn-term-accent text-xs inline-flex items-center gap-2"
                >
                    <Home className="w-3.5 h-3.5" />
                    [ cd ~ ]
                </Link>
            </motion.div>
        </div>
    )
}
